// Funciones auxiliares para controles.
//import * as FxLog from './FxLog';
import { BsAsterisk } from "react-icons/bs"; 
import { BiHelpCircle } from "react-icons/bi"; 
import { Tooltip } from "@material-ui/core";

export const getLabel = (label, isRequired, labelTooltip) => {
  let ar = JSON.parse(sessionStorage.getItem('trans') || null);
  let strTransRequired = ar ? ar['field.required'] : '';

  // Función interna para formatear el texto y evitar el "caracter raro"
  const formatText = (txt) => (
    <div style={{ whiteSpace: 'pre-line', display: 'block' }}>
      {txt}
    </div>
  );

  return label && <span style={{ display: 'flex', flexDirection: 'row' }}>
    <span>{label}</span>
    {isRequired && 
      <Tooltip title={formatText(strTransRequired)} >
        <span style={{ margin: '-0px 0 0 3px', color: 'var(--ibs_color_red)' }}><BsAsterisk fontSize="13px" /></span>
      </Tooltip>
    }

    {labelTooltip && 
      <Tooltip title={formatText(labelTooltip)} >
        <span style={{ margin: '-2px 0 0 1px', color: 'var(--ibs_color_blue)' }}><BiHelpCircle fontSize="18px" /></span>
      </Tooltip>
    }
  </span>
}